// extracted by mini-css-extract-plugin
export default {"colorSwatch":"ColorPicker_colorSwatch__wGHWE","colorPicker":"ColorPicker_colorPicker__5ExG7","colorPickerContainer":"ColorPicker_colorPickerContainer__G7j5e"};